var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"raca","rota-base":"/admin/raca","titulo":"RAÇAS / COR","titulo-singular":"Raça/Cor","colunas-extras":[{"campo":"cod_censo","label":"Código INEP","tipo":"string"}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }